module.exports = __webpack_public_path__ + "img/grid-sample10.4bf6aa18.jpg";